import { render } from "./SmartboxForm.vue?vue&type=template&id=87f7f5a4"
import script from "./SmartboxForm.vue?vue&type=script&lang=js"
export * from "./SmartboxForm.vue?vue&type=script&lang=js"
script.render = render

export default script